import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSessionStore } from '../store/sessionStore';
import './GameSettings.css';

/** Панель настроек длительности отрывка и задержки инфо. */
export const GameSettings = () => {
  const settings = useSessionStore((state) => state.session.settings);
  const updateSettings = useSessionStore((state) => state.updateSettings);
  const [localSettings, setLocalSettings] = useState(settings);
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setLocalSettings(settings);
  }, [settings]);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleSave = async () => {
    try {
      await updateSettings(localSettings);
    } catch (error) {
      console.error('Ошибка сохранения настроек пакета:', error);
      alert('Ошибка сохранения настроек.');
    }
    setIsOpen(false);
  };

  const panelContent = isOpen ? (
    <div className="game-settings-panel">
      <h3>Настройки игры</h3>
      <div className="game-settings-field">
        <label>
          Длительность воспроизведения (секунды):
          <input
            type="number"
            min="5"
            max="60"
            value={localSettings.defaultPlayDuration}
            onChange={(e) =>
              setLocalSettings({
                ...localSettings,
                defaultPlayDuration: parseInt(e.target.value, 10),
              })
            }
          />
        </label>
      </div>
      <div className="game-settings-field">
        <label>
          Задержка перед показом информации (секунды):
          <input
            type="number"
            min="0"
            max="30"
            value={localSettings.infoDisplayDelay}
            onChange={(e) =>
              setLocalSettings({
                ...localSettings,
                infoDisplayDelay: parseInt(e.target.value, 10),
              })
            }
          />
        </label>
      </div>
      <div className="game-settings-actions">
        <button onClick={handleSave} className="game-settings-save">
          Сохранить
        </button>
        <button
          onClick={() => {
            setLocalSettings(settings);
            setIsOpen(false);
          }}
          className="game-settings-cancel"
        >
          Отмена
        </button>
      </div>
    </div>
  ) : null;

  return (
    <div className="game-settings">
      <button className="game-settings-toggle" onClick={() => setIsOpen(!isOpen)}>
        Настройки
      </button>
      {mounted && createPortal(panelContent, document.body)}
    </div>
  );
};
